import { useNavigate } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";

export default function VerifyGate({ open, onClose }) {
  const navigate = useNavigate();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm p-4"
      data-testid="verify-gate-modal"
    >
      <div className="bg-white rounded-2xl border border-[#DEDBD3] w-full max-w-md p-8 text-center animate-fade-up relative">
        <button
          onClick={onClose}
          data-testid="verify-gate-close"
          className="absolute top-4 right-4 text-[#A3A095] hover:text-[#1A1A1A]"
        >
          <X size={20} />
        </button>
        <div className="mx-auto w-16 h-16 rounded-full bg-[#F0EBE1] flex items-center justify-center text-[#1B4D3E]">
          <ShieldCheck size={30} strokeWidth={1.5} />
        </div>
        <h3 className="font-serif-dl text-3xl tracking-tight mt-5">Verify to seal</h3>
        <p className="text-[#5C5A54] mt-3 leading-relaxed">
          Sealing a dap requires a verified identity — your word should be worth
          something. Verify your phone to continue.
        </p>
        <button
          data-testid="verify-gate-cta"
          onClick={() => navigate("/settings")}
          className="mt-6 w-full py-3.5 bg-[#1B4D3E] text-white rounded-lg font-serif-dl text-lg tracking-wide hover:bg-[#143A2F] transition-colors"
        >
          Verify my identity
        </button>
      </div>
    </div>
  );
}
